import Vue from "vue";
import VueRouter from "vue-router";
import axios from 'axios';
import { msg } from '../plugins/common';
import store from '../store/index.js'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: { requiresAuth: true }, 
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/charging",
    name: "Charging",
    component: () => import("../views/Charging.vue"),
    meta: {
      title: "月票繳費",
      level: 2,
      requiresAuth: true
    },
  },
  {
    path: '/confirm',
    name: 'OrderConfirm',
    component: () => import('../views/Confirm.vue'),
    meta: {
      title: '付款確認',
      level: 2
    },
  },
  {
    path: "/tradeinfo",
    name: "TradeInfo",
    component: () => import("../views/TradeInfo.vue"),
    meta: {
      title: "查詢交易紀錄",
      level: 2,
      requiresAuth: true
    },
  },
  {
    path: "/changeprofile",
    name: "ChangeProfile",
    component: () => import("../views/ChangeProfile.vue"),
    meta: {
      title: "註冊手機載具",
      level: 2,
      requiresAuth: true
    },
  },
];

const router = new VueRouter({
  routes,
});

// 路由守衛檢查 session 狀態
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      const response = await axios.create({
        baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
        timeout: process.env.REQ_TIMEOUT, // request timeout
        withCredentials: true
      }).get('/Auth/CheckState'); // 向後端檢查 session 狀態
      if (response.data.IsLoggedIn) {
        store.dispatch("loginstatus/setLoginStatus", {status: true, changePWD: response.data.ForceChangePWD});
        next();
      } else {
        store.dispatch("loginstatus/setLoginStatus", {status: false});
        msg("查無租戶資訊，請重新登入", 3000);
        next({ path: '/login' }); // 若未登入，導回首頁
      }
    } catch (error) {
      msg("查無租戶資訊，請重新登入", 3000);
      next({ path: '/login' }); // 若發生錯誤（如 401），也導回首頁
    }
  } else if(to.matched.some(record => record.name == 'Login')) {
    try {
      const response = await axios.create({
        baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
        timeout: process.env.REQ_TIMEOUT, // request timeout
        withCredentials: true
      }).get('/Auth/CheckState'); // 向後端檢查 session 狀態
      if (response.data.IsLoggedIn) {
        store.dispatch("loginstatus/setLoginStatus", {status: true, changePWD: response.data.ForceChangePWD});
        next({ path: '/' }); 
      } else {
        store.dispatch("loginstatus/setLoginStatus", {status: false});
        next();
      }
    } catch (error) {
      msg("查無租戶資訊，請重新登入", 3000);
      next();
    }
  }else {
    next();
  }
});

export default router;
